var assert = require('proclaim');
var expect = assert.strictEqual;
